module.exports = __webpack_public_path__ + "static/media/Colette Wing Super King Headboard - 200 cm.9c70fa7c.jpg";